"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentAuditListItemDtoStatusEnum = exports.DocumentAuditListItemDtoDocumentTypeEnum = void 0;
exports.instanceOfDocumentAuditListItemDto = instanceOfDocumentAuditListItemDto;
exports.DocumentAuditListItemDtoFromJSON = DocumentAuditListItemDtoFromJSON;
exports.DocumentAuditListItemDtoFromJSONTyped = DocumentAuditListItemDtoFromJSONTyped;
exports.DocumentAuditListItemDtoToJSON = DocumentAuditListItemDtoToJSON;
exports.DocumentAuditListItemDtoToJSONTyped = DocumentAuditListItemDtoToJSONTyped;
const DocumentAuditValidationResultDto_1 = require("./DocumentAuditValidationResultDto");
const DocumentAuditProfileDto_1 = require("./DocumentAuditProfileDto");
/**
 * @export
 */
exports.DocumentAuditListItemDtoDocumentTypeEnum = {
    AdminChatAttachment: 'ADMIN_CHAT_ATTACHMENT',
    Certification: 'CERTIFICATION',
    DhsClearanceLetter: 'DHS_CLEARANCE_LETTER',
    DhsRegistryCheckResult: 'DHS_REGISTRY_CHECK_RESULT',
    Orientation: 'ORIENTATION',
    Vaccination: 'VACCINATION'
};
/**
 * @export
 */
exports.DocumentAuditListItemDtoStatusEnum = {
    NeedsReview: 'NEEDS_REVIEW',
    Approved: 'APPROVED',
    Rejected: 'REJECTED'
};
/**
 * Check if a given object implements the DocumentAuditListItemDto interface.
 */
function instanceOfDocumentAuditListItemDto(value) {
    if (!('storedDocumentId' in value) || value['storedDocumentId'] === undefined)
        return false;
    if (!('documentType' in value) || value['documentType'] === undefined)
        return false;
    if (!('fileName' in value) || value['fileName'] === undefined)
        return false;
    if (!('uploadedAt' in value) || value['uploadedAt'] === undefined)
        return false;
    if (!('ownedBy' in value) || value['ownedBy'] === undefined)
        return false;
    if (!('uploadedBy' in value) || value['uploadedBy'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('isExpired' in value) || value['isExpired'] === undefined)
        return false;
    if (!('humanResult' in value) || value['humanResult'] === undefined)
        return false;
    if (!('llmResult' in value) || value['llmResult'] === undefined)
        return false;
    if (!('externalResult' in value) || value['externalResult'] === undefined)
        return false;
    return true;
}
function DocumentAuditListItemDtoFromJSON(json) {
    return DocumentAuditListItemDtoFromJSONTyped(json, false);
}
function DocumentAuditListItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'storedDocumentId': json['storedDocumentId'],
        'documentType': json['documentType'],
        'fileName': json['fileName'],
        'uploadedAt': (new Date(json['uploadedAt'])),
        'ownedBy': (0, DocumentAuditProfileDto_1.DocumentAuditProfileDtoFromJSON)(json['ownedBy']),
        'uploadedBy': (0, DocumentAuditProfileDto_1.DocumentAuditProfileDtoFromJSON)(json['uploadedBy']),
        'status': json['status'],
        'isExpired': json['isExpired'],
        'humanResult': (0, DocumentAuditValidationResultDto_1.DocumentAuditValidationResultDtoFromJSON)(json['humanResult']),
        'llmResult': (0, DocumentAuditValidationResultDto_1.DocumentAuditValidationResultDtoFromJSON)(json['llmResult']),
        'externalResult': (0, DocumentAuditValidationResultDto_1.DocumentAuditValidationResultDtoFromJSON)(json['externalResult']),
    };
}
function DocumentAuditListItemDtoToJSON(json) {
    return DocumentAuditListItemDtoToJSONTyped(json, false);
}
function DocumentAuditListItemDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'storedDocumentId': value['storedDocumentId'],
        'documentType': value['documentType'],
        'fileName': value['fileName'],
        'uploadedAt': ((value['uploadedAt']).toISOString()),
        'ownedBy': (0, DocumentAuditProfileDto_1.DocumentAuditProfileDtoToJSON)(value['ownedBy']),
        'uploadedBy': (0, DocumentAuditProfileDto_1.DocumentAuditProfileDtoToJSON)(value['uploadedBy']),
        'status': value['status'],
        'isExpired': value['isExpired'],
        'humanResult': (0, DocumentAuditValidationResultDto_1.DocumentAuditValidationResultDtoToJSON)(value['humanResult']),
        'llmResult': (0, DocumentAuditValidationResultDto_1.DocumentAuditValidationResultDtoToJSON)(value['llmResult']),
        'externalResult': (0, DocumentAuditValidationResultDto_1.DocumentAuditValidationResultDtoToJSON)(value['externalResult']),
    };
}
//# sourceMappingURL=DocumentAuditListItemDto.js.map